var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 4.95652C0 2.21911 2.21911 0 4.95652 0H71.0435C73.7809 0 76 2.21911 76 4.95652V71.0435C76 73.7809 73.7809 76 71.0435 76H4.95652C2.21911 76 0 73.7809 0 71.0435V4.95652Z","fill":"#BCE9CB","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M58.3814 23.9767C59.7379 25.1975 59.8479 27.2868 58.627 28.6433L36.3227 53.4259C35.6897 54.1292 34.7855 54.5275 33.8393 54.5196C32.8931 54.5118 31.9956 54.0987 31.3743 53.385L18.983 39.1509C17.7848 37.7745 17.9292 35.6873 19.3057 34.489C20.6821 33.2908 22.7693 33.4352 23.9676 34.8117L33.9078 46.2302L53.7148 24.2223C54.9357 22.8658 57.025 22.7559 58.3814 23.9767Z","fill":"#2F6F45","key":1})]);
}

Success.defaultProps = {"width":"76","height":"76","viewBox":"0 0 76 76","fill":"none"};

module.exports = Success;

Success.default = Success;
